import React, { useState, useRef, useEffect } from 'react';
import Select from '../Select';
import { loader } from 'graphql.macro';
import { useQuery } from 'react-apollo-hooks';

const SEARCH_CLIENTS_QUERY = loader('../../gql/queries/SearchClients.gql');

const findClients = (resolver, items, oldText, setText) => text =>
  new Promise(resolve => {
    const input = text || '';
    if (input.length === 0) {
      resolve([]);
      return;
    }

    if (oldText === text) {
      resolve(items);
    } else {
      setText(text);
      resolver.current = resolve;
    }
  });

const ClientSelect = props => {
  const [text, setText] = useState('');
  const [items, setItems] = useState([]);
  const resolver = useRef();
  const { data, loading, refetch } = useQuery(SEARCH_CLIENTS_QUERY, {
    variables: { text: '', limit: 0 },
  });

  useEffect(() => {
    if (!text) return;
    refetch({ text, limit: 50 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  useEffect(() => {
    if (!loading && resolver.current) {
      const { clients } = data.clients;
      const newItems = clients.map(client => ({
        id: client.id,
        value: client.id,
        label: client.fullName,
        main: client.fullName,
        secondary: [client.phone, client.email].filter(v => !!v).join(', '),
        client,
      }));
      resolver.current(newItems);
      resolver.current = null;
      setItems(newItems);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, data]);

  return <Select items={findClients(resolver, items, text, setText)} {...props} />;
};

export default ClientSelect;
